import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface UpdateWriteOffListParams {
  batchId: string;
  file: File;
}

export const useUpdateWriteOffList = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ batchId, file }: UpdateWriteOffListParams) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('batchId', batchId);

      const result = await apiClient.batchesReports.updateWriteOffList.mutation({ body: formData });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, { batchId }) => {
      queryClient.invalidateQueries({ queryKey: ['retrieve-declaration-finalize', batchId] });
      toast.success('Write-off list updated successfully!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error updating write-off list!');
    },
  });
};
